/**
 * Concat path to defailt mock server URL
 * @param path => Path to concat
 * @returns => Server URL
 */
export function mockServerApi(path: string) {
  return process.env.VUE_APP_API_URI + path;
}

export default mockServerApi;
